import { getWidgetRenderer } from '../widgets';

export function resolveWidgetRenderer(widgetType) {
  return getWidgetRenderer(widgetType);
}
